import { render } from "./management.vue?vue&type=template&id=d1541c76&scoped=true&ts=true"
import script from "./management.vue?vue&type=script&lang=ts"
export * from "./management.vue?vue&type=script&lang=ts"

import "./management.vue?vue&type=style&index=0&id=d1541c76&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1541c76"]])

export default __exports__